const searchInput = document.querySelector('.header-search__input-field');

const toggleSearchClass = (toggle) => {
  document.body.classList.toggle('is-search-open', toggle);
};

const toggleMenuClass = (toggle) => {
  document.body.classList.toggle('is-open-menu', toggle);
};

const toggleQuickNavClass = (toggle) => {
  document.body.classList.toggle('is-open-quick-nav', toggle);
};

// ------
// Mobile menu toggle
// ------

attachEvent('.mobile-hamburger', 'click', (ev) => {
  ev.preventDefault();
  const isOpen = document.body.classList.contains('is-open-menu');
  toggleQuickNavClass(false);
  toggleSearchClass(false);
  toggleMenuClass(!isOpen);
});

// ------
// Add class to body after some scroll
// ------
function addScrollingClass() {
  const topOffert = document.documentElement.scrollTop || document.body.scrollTop;
  document.body.classList.toggle('is-scrolled', topOffert > 20);
}

let ticking = false;
document.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      addScrollingClass();
      ticking = false;
    });
    ticking = true;
  }
});

let lastScrollTop = 0;
const addClassOnScroll = () => {
  const isScrolledTop = window.pageYOffset || document.documentElement.scrollTop;
  document.body.classList.toggle('is-scrolled-up', isScrolledTop < lastScrollTop);
  lastScrollTop = isScrolledTop <= 0 ? 0 : isScrolledTop;
};

window.addEventListener(
  'scroll',
  () => {
    addClassOnScroll();
  },
  false,
);

addClassOnScroll();

// ------
// Open Quick nav
// ------

attachEvent('.quick-nav-hamburger', 'click', (ev) => {
  if (!ev.target.closest('button').classList.contains('scroll-down-btn')) {
    const isOpen = document.body.classList.contains('is-open-quick-nav');
    toggleSearchClass(false);
    toggleMenuClass(false);
    toggleQuickNavClass(!isOpen);
    ev.preventDefault();
  }
});

// ------
// Open search
// ------

attachEvent('.header-main__search-btn', 'click', (ev) => {
  const isOpen = document.body.classList.contains('is-search-open');
  searchInput.focus();
  toggleMenuClass(false);
  toggleQuickNavClass(false);
  toggleSearchClass(!isOpen);
  ev.preventDefault();
});

// *******************************************************************************
// Close Search When Click Out
// *******************************************************************************

document.addEventListener('click', (evt) => {
  const headerSearchBtn = document.querySelector('.header-main__search-btn');
  const headerSearchContainer = document.querySelector('.header-search__form');

  let targetElement = evt.target; // clicked element

  do {
    if (targetElement === headerSearchContainer || targetElement === headerSearchBtn) {
      return;
    }
    targetElement = targetElement.parentNode;
  } while (targetElement);

  toggleSearchClass(false);
  if (searchInput) {
    searchInput.blur();
  }
});

// *******************************************************************************
// Close Search When Escape Key Press
// *******************************************************************************

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    toggleSearchClass(false);
    searchInput.blur();
  }
});

// *******************************************************************************
// Click on mobile tabs
// *******************************************************************************
const closeOtherMenuItems = () => {
  document.querySelectorAll('.menu__item.has-submenu').forEach((el) => {
    el.classList.remove('is-open-submenu');
  });
  document.querySelectorAll('.mega-menu__has-sub').forEach((el) => {
    el.classList.remove('is-open-mega-submenu');
  });
};

attachEvent('[data-menu-target]', 'click', (ev) => {
  if (ev.target.getAttribute('href') === '#') {
    ev.preventDefault();
    toggleQuickNavClass(false);
    toggleSearchClass(false);
    toggleMenuClass(true);

    const targetMenu = ev.target.getAttribute('data-menu-target');
    const selectedMenuItem = document.querySelector(`[data-menu="${targetMenu}"]`);

    if (!selectedMenuItem.classList.contains('is-open-submenu')) {
      closeOtherMenuItems();
      const menuArrow = selectedMenuItem.querySelector('.menu__arrow');
      menuArrow.click();
    }
  }
});

// **************************************************
// Add content ID to first element after hero
// **************************************************

window.addEventListener('DOMContentLoaded', () => {
  const mainDiv = document.querySelector('main');
  if (mainDiv) {
    const item = document.querySelector('main > *:first-of-type');
    const heroBanner = mainDiv.querySelector('.sc-hero-banner');
    const bannerModule = mainDiv.querySelector('.sc-banner-module');
    const heroSlider = mainDiv.querySelector('.sc-hero-slider');

    if (item === heroBanner || item === bannerModule || item === heroSlider) {
      item.nextElementSibling.setAttribute('id', 'content');
    } else {
      item.setAttribute('id', 'content');
    }
  }
});
